var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4349_10082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9969 0.674805C5.73438 0.674805 0.671875 5.7373 0.671875 11.9998C0.671875 18.2623 5.73438 23.3623 11.9969 23.3623C18.2594 23.3623 23.3594 18.2623 23.3594 11.9998C23.3594 5.7373 18.2594 0.674805 11.9969 0.674805ZM11.9969 21.6748C6.67188 21.6748 2.35938 17.3248 2.35938 11.9998C2.35938 6.67481 6.67188 2.3623 11.9969 2.3623C17.3219 2.3623 21.6719 6.7123 21.6719 12.0373C21.6719 17.3248 17.3219 21.6748 11.9969 21.6748Z",
    fill: "#60C2A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6703 4.53705C11.5828 4.34955 10.4578 4.64955 9.63281 5.36205C8.80781 6.07455 8.32031 7.08705 8.32031 8.21205C8.32031 8.62455 8.39531 9.03705 8.54531 9.44955C8.69531 9.89955 9.18281 10.1246 9.63281 9.97455C10.0828 9.82455 10.3078 9.33705 10.1578 8.88705C10.0828 8.66205 10.0453 8.43705 10.0453 8.21205C10.0453 7.61205 10.3078 7.04955 10.7578 6.67455C11.2078 6.29955 11.8078 6.11205 12.4453 6.22455C13.2328 6.37455 13.9078 7.04955 14.0578 7.83705C14.2078 8.77455 13.7203 9.71205 12.8578 10.0871C11.8828 10.4996 11.2453 11.4746 11.2453 12.5996V14.9246C11.2453 15.3746 11.6203 15.7871 12.1078 15.7871C12.5578 15.7871 12.9703 15.4121 12.9703 14.9246V12.5996C12.9703 12.1871 13.1953 11.8121 13.5328 11.6621C15.1453 10.9871 16.0828 9.29955 15.7828 7.57455C15.3703 6.03705 14.1703 4.79955 12.6703 4.53705Z",
    fill: "#60C2A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0375 17.1748H11.925C11.475 17.1748 11.0625 17.5498 11.0625 18.0373C11.0625 18.5248 11.4375 18.8998 11.925 18.8998H12.0375C12.4875 18.8998 12.8625 18.5248 12.8625 18.0373C12.8625 17.5498 12.525 17.1748 12.0375 17.1748Z",
    fill: "#60C2A5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4349_10082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircle);
export default __webpack_public_path__ + "static/media/question-circle.f19720974fa28479e52b6d52deb577b8.svg";
export { ForwardRef as ReactComponent };